// extracted by mini-css-extract-plugin
module.exports = {"root":"switch-label_root__XRJJV","sm":"switch-label_sm__oXuN7","md":"switch-label_md___uluA"};